import { render, staticRenderFns } from "./center_1.vue?vue&type=template&id=1f861548&scoped=true&"
import script from "./center_1.vue?vue&type=script&lang=js&"
export * from "./center_1.vue?vue&type=script&lang=js&"
import style0 from "./center_1.vue?vue&type=style&index=0&id=1f861548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f861548",
  null
  
)

export default component.exports